import { useCallback, useEffect, useState } from "react";
var useElementScroll = function (ref) {
    var _a = useState({
        top: 0,
        bottom: 0,
    }), scrollX = _a[0], setScrollX = _a[1];
    var _b = useState({
        left: 0,
        right: 0,
    }), scrollY = _b[0], setScrollY = _b[1];
    var updateScroll = useCallback(function (element) {
        setScrollX({
            top: element.scrollTop,
            bottom: element.scrollHeight - element.clientHeight - element.scrollTop,
        });
        setScrollY({
            left: element.scrollLeft,
            right: element.scrollWidth - element.clientWidth - element.scrollLeft,
        });
    }, []);
    useEffect(function () {
        var element = ref.current;
        if (!element) {
            return;
        }
        updateScroll(element);
        var resizeScrollCallback = function () {
            updateScroll(element);
        };
        element.addEventListener("scroll", resizeScrollCallback);
        window.addEventListener("resize", resizeScrollCallback);
        return function () {
            element.removeEventListener("scroll", resizeScrollCallback);
            window.removeEventListener("resize", resizeScrollCallback);
        };
    }, [updateScroll, ref]);
    return { scrollX: scrollX, scrollY: scrollY };
};
export default useElementScroll;
//# sourceMappingURL=useElementScroll.js.map